import { Box, Icon, Text, dimensions } from '@factorialco/deprecated-design-system'
import {
  EmployeeViewCostHistoryRecordsFragment,
  ProjectWorkerCostHistoryRecordsFragment,
} from 'generated/resources/graphql'
import moment from 'moment'

import ProjectWorkerCard from './ProjectWorkerCard'

interface ICostHistoryRecord {
  costHistoryRecords:
    | ProjectWorkerCostHistoryRecordsFragment[]
    | EmployeeViewCostHistoryRecordsFragment[]
  laborCostCurrency: string
}

const CostHistoryRecords = ({ costHistoryRecords, laborCostCurrency }: ICostHistoryRecord) => {
  return (
    <>
      <Box background="grey300" style={{ width: '2px', marginTop: dimensions.s16 }} />
      <Box width="full">
        {costHistoryRecords.map((record, index) => (
          <>
            <Box flexDirection="row" alignItems="center" gap="s16">
              <Box
                style={{ marginLeft: `calc(-${dimensions.s6} - ${dimensions.s1})` }}
                paddingY="s12"
              >
                <Icon.Tiny icon="circle" color="grey800" />
              </Box>
              <Text size="200" weight="medium" color="grey800">
                {moment(record.yearMonth, 'YYYY-M').format('MMMM YYYY')}
              </Text>
            </Box>
            <Box padding="s16">
              <ProjectWorkerCard
                key={index}
                originalCostCents={record.originalCostCents}
                originalCostCurrency={record.originalCostCurrency}
                laborCostCents={
                  record.legalEntityCompanyCostCents > 0
                    ? record.legalEntityCompanyCostCents
                    : record.originalCostCents
                }
                laborCostCurrency={laborCostCurrency}
                imputedMinutes={record.imputedMinutes}
                exchangeDate={record.exchangeDate}
                yearMonth={record.yearMonth}
              />
            </Box>
          </>
        ))}
      </Box>
    </>
  )
}

export default CostHistoryRecords
